/** @format */

import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { useMemo } from 'react';
import { Button } from 'src/components';

export default function AdministrationActionConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  cancelLabel,
  confirmLabel,
  error,
  confirmDisabled = false
}) {
  const baseId = useMemo(() => `admin-action-confirm-${Math.random().toString(36).slice(2, 11)}`, []);
  const titleId = `${baseId}-title`;
  const messageId = `${baseId}-message`;

  const handleDialogClose = (event, reason) => {
    if (confirmDisabled && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby={title ? titleId : messageId}
      aria-describedby={title ? messageId : undefined}
      PaperProps={{ className: 'admin-action-confirm-dialog' }}>
      <DialogContent className="admin-action-confirm-dialog__content">
        {title ? (
          <p id={titleId} className="admin-action-confirm-dialog__title">
            {title}
          </p>
        ) : null}
        <p id={messageId} className="admin-action-confirm-dialog__message">
          {message}
        </p>
      </DialogContent>
      <DialogActions className="admin-action-confirm-dialog__actions">
        {error ? <p className="admin-action-confirm-dialog__error">{error}</p> : null}
        <Button
          type="button"
          secondary
          onClick={onClose}
          disabled={confirmDisabled}
          label={cancelLabel}
        />
        <Button type="button" onClick={onConfirm} disabled={confirmDisabled} label={confirmLabel} />
      </DialogActions>
    </Dialog>
  );
}
